export const resizeCaptureMixin = {
  data () {
    return {
      clientHeight: document.body.clientHeight,
      clientWidth: document.body.clientWidth
    }
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        this.clientHeight = document.body.clientHeight
        this.clientWidth = document.body.clientWidth
      })()
    }
  }
}
